import apiClient from "./client";

/**
 * Documentação de integração com o myGROW (#1782), servida pela api atrás do login.
 *
 * O dicionário e a referência saem do código (os modelos da API de carga e o OpenAPI), e por
 * isso não envelhecem. A descrição de cada campo vem em português; a tela a traduz pela
 * `description_key` (`load_v1.<tabela>.<campo>`), como as `ref_*` fazem com `display_name_key`.
 */

export interface LoadDictionaryField {
  name: string;
  type: string;
  format?: string;
  values?: string[];
  items?: string;
  max_length?: number;
  minimum?: number;
  nullable: boolean;
  required: boolean;
  key: boolean;
  description: string;
  description_key: string;
}

export interface LoadDictionaryTable {
  name: string;
  key_columns: string[];
  fields: LoadDictionaryField[];
}

export interface LoadDictionaryDomain {
  name: string;
  tables: LoadDictionaryTable[];
}

export interface LoadDictionary {
  api_version: string;
  domains: LoadDictionaryDomain[];
}

export interface ManifestField {
  name: string;
  type: string;
  format?: string;
  values?: string[];
  items?: string;
  max_length?: number;
  minimum?: number;
  /** O bloco que o campo é, quando é outro bloco do manifesto. */
  ref?: string;
  nullable: boolean;
  required: boolean;
  description: string;
  description_key: string;
}

export interface ManifestBlock {
  name: string;
  /** Onde o bloco aparece no manifesto, como `domains.documents_and_volumes.document_classes[]`. */
  paths: string[];
  description: string;
  description_key: string;
  fields: ManifestField[];
}

/** Os blocos do manifesto vigente, da raiz para dentro; traduzidos por `manifest_v<versão>.*`. */
export interface ManifestDictionary {
  manifest_version: string;
  schema_id: string;
  blocks: ManifestBlock[];
}

export interface LoadApiOperation {
  summary?: string;
  description?: string;
  parameters?: { name: string; in: string; required?: boolean }[];
  requestBody?: unknown;
  responses?: Record<string, { description?: string }>;
}

export interface LoadApiReference {
  openapi?: string;
  info?: { title?: string; version?: string };
  paths: Record<string, Record<string, LoadApiOperation>>;
  components: { schemas: Record<string, unknown> };
}

export async function getLoadDictionary(): Promise<LoadDictionary> {
  const res = await apiClient.get<LoadDictionary>("/api/integration/dictionary");
  return res.data;
}

export async function getManifestDictionary(): Promise<ManifestDictionary> {
  const res = await apiClient.get<ManifestDictionary>("/api/integration/manifest");
  return res.data;
}

export async function getLoadApiReference(): Promise<LoadApiReference> {
  const res = await apiClient.get<LoadApiReference>("/api/integration/api-reference");
  return res.data;
}
